import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { Provider } from "react-redux";
import generateStore from "./redux/store";
import { PersistGate } from 'redux-persist/integration/react'
 
const {store, persistor} = generateStore()

//Interceptor de axios JWT
import interceptorJWT from './components/Interceptors/InterceptorAxiosJWT';


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
